import "./style.scss";
import { FC, MouseEventHandler, ReactNode } from "react";

interface IBtnDefault {
  reverse?: boolean;
  disabled?: boolean;
  onlyIcon?: boolean;
  // style?: CSSProperties;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  // customClass?: string;
}

const BtnDefault: FC<IBtnDefault> = ({ reverse, disabled, children, onClick, onlyIcon }) => {
  return (
    <div
      className={`btn-default ${reverse ? "reverse" : ""} ${disabled ? "disabled" : ""} ${onlyIcon ? "only-icon" : ""}`}
      // style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default BtnDefault;
